<!-- 出入金详情页组件 -->
<template>
  <div class="scroll-page" ref="scrollwrapper">
    <AppHeader @refreshPage="init" />
    <div class="detail-bg"></div>
    <div
      class="container"
      v-infinite-scroll="loadMore"
      :infinite-scroll-disabled="loading"
      infinite-scroll-distance="10">
      <div class="page-header">
        <div class="icon-bar back" @click="handleBack"></div>
        <div class="page-title sub">
          {{ $t('add.text87') }}
        </div>
      </div>
      <div class="detail-box">
        <div class="list1 type2" v-if="list && list.length > 0">
          <div class="item" v-for="(item, index) in list" :key="index">
            <div class="flexable">
              <div class="text" :class="item.source === 1 ? 'text0' : 'text1'">
                <div class="label" @click="handleQa(item.source)">
                  {{ item.source === 1 ? $t('web5token') : $t('krazetoken') }}
                </div>
                <div class="value">
                  {{ $handleNum(item.score) }}
                </div>
              </div>
              <div class="btns ar" @click="handleStatus(item)">
                <div class="status" :class="'status' + item.status">
                  {{ item.category_name }}
                </div>
                <div class="des">{{ item.created_at }}</div>
              </div>
            </div>
          </div>
          <div class="no-more" v-if="!queryParams.more">
            - {{ $t('add.text73') }} -
          </div>
        </div>
        <EmptyBox
          :text="$t('add.text85')"
          style="margin-top: 2rem"
          type="nft"
          v-if="list && list.length == 0" />
      </div>
      <div class="open-area" style="height: 0.5rem"></div>
    </div>
    <mt-popup
      v-model="popupVisible"
      position="bottom"
      :closeOnClickModal="false">
      <div class="pop-box">
        <div class="pop-title" style="margin-bottom: -0.44rem">
          {{ $t('add.text100') }}
        </div>
        <div class="result-box">
          <div class="des al type2" v-html="$t('add.text86')"></div>
        </div>
        <el-button
          class="el-button--white block"
          style="margin-top: 0.7rem"
          @click="handleRoute"
          >{{ $t('ok') }}</el-button
        >
      </div>

      <div
        class="pop-close"
        @click="
          () => {
            this.popupVisible = false
          }
        "></div>
    </mt-popup>
  </div>
</template>
<script>
import EmptyBox from '@/components/EmptyBox.vue'

export default {
  props: {
    from: {
      type: String,
      default: () => 'user'
    },
    api: {
      type: Function,
      default: () => {}
    }
  },
  components: { EmptyBox },
  data() {
    return {
      list: null,
      popupVisible: false,
      queryParams: {
        page: 1,
        size: 10,
        more: true
      }
    }
  },
  watch: {
    '$i18n.locale'() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    loadMore() {
      console.log('load')
      if (this.queryParams.more) {
        this.queryParams.page += 1
        this.getList()
      }
    },
    init() {
      this.list = null
      this.queryParams = {
        page: 1,
        size: 10,
        more: true
      }
      this.getList()
    },
    getList() {
      this.loading = true
      let params = {
        page: this.queryParams.page,
        size: this.queryParams.size
      }
      this.api(params).then((res) => {
        this.loading = false
        if (!this.list) {
          this.list = []
        }
        this.list = this.list.concat(res.data.lists.data)
        if (res.data.lists.data.length < this.queryParams.size) {
          this.queryParams.more = false
        }
        this.loading = false
      })
    },
    handleActivity(item) {
      if (item.status === 1) {
        this.handleRoute('/user/activity', item)
      } else {
        this.handleRoute('/user/actdetail', item)
      }
    },
    handleBack() {
      this.$router.back()
    },
    handleRoute(path, item) {
      if (item) {
        this.$router.push({ path: path, query: { rec_code: item.rec_code } })
      } else {
        this.$router.push({ path: path })
      }
    },
    handleQa(source) {
      let type = source.toString()
      this.$router.push({ path: '/user/qa', query: { type: type } })
    },
    handleStatus(item) {
      if (item.status !== 3) {
        this.popupVisible = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TransferListBox.vue